// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* tables.css */

/* Link colours in active table rows.
   When table rows are selected, the following increases the contrast between the link colour and background colour.
 */
[data-bs-theme="dark"] .table-active a {
    color: #fff;
}
[data-bs-theme="light"] .table-active a {
    color: #000;
}

.table-cell-select,
.table-cell-status {
    width: 30px;
    text-align: center;
}

.table-cell-order,
.table-cell-type-currency,
.table-cell-type-number {
    text-align: right;
}

.table tbody td .btn-sm {
    padding-top: 0;
    padding-bottom: 0;
    line-height: inherit;
}

/* Table cell hidden icon */

.table-cell-hidden-icon-parent {
    display: flex;
}

.table-cell-hidden-icon {
    margin-left: 10px;
    visibility: hidden;
}

.table-cell-hidden-icon-parent:hover > .table-cell-hidden-icon {
    visibility: visible;
}

.table-dashed.table > :not(caption) > * > * {
    border-style: dashed;
}`, "",{"version":3,"sources":["webpack://./src/css/tables.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;;EAEE;AACF;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA,2BAA2B;;AAE3B;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["/* tables.css */\n\n/* Link colours in active table rows.\n   When table rows are selected, the following increases the contrast between the link colour and background colour.\n */\n[data-bs-theme=\"dark\"] .table-active a {\n    color: #fff;\n}\n[data-bs-theme=\"light\"] .table-active a {\n    color: #000;\n}\n\n.table-cell-select,\n.table-cell-status {\n    width: 30px;\n    text-align: center;\n}\n\n.table-cell-order,\n.table-cell-type-currency,\n.table-cell-type-number {\n    text-align: right;\n}\n\n.table tbody td .btn-sm {\n    padding-top: 0;\n    padding-bottom: 0;\n    line-height: inherit;\n}\n\n/* Table cell hidden icon */\n\n.table-cell-hidden-icon-parent {\n    display: flex;\n}\n\n.table-cell-hidden-icon {\n    margin-left: 10px;\n    visibility: hidden;\n}\n\n.table-cell-hidden-icon-parent:hover > .table-cell-hidden-icon {\n    visibility: visible;\n}\n\n.table-dashed.table > :not(caption) > * > * {\n    border-style: dashed;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
